import CloseIcon from '@mui/icons-material/Close';
import { Box, styled } from '@mui/material';
import type { AlertProps } from '@mui/material/Alert';
import MuiAlert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';

const StyAlert = styled(MuiAlert, {
    name: 'StyAlert',
})(({ theme }) => ({
    padding: '1rem 1.5rem',
    borderRadius: '0.25rem',
    '&.MuiAlert-standard.MuiAlert-colorInfo': {
        backgroundColor: theme.palette.primary.background,
    },
}));

const StyColoredText = styled(Typography, {
    name: 'StyColoredText',
})(({ theme }) => ({
    color: theme.palette.darkGrey,
}));

const Alert = ({
    severity,
    icon,
    action,
    children,
    onClose,
    className,
}: AlertProps) => (
    <StyAlert
        className={className}
        severity={severity}
        icon={icon}
        action={
            <Box sx={{ display: 'flex' }}>
                {action}
                {onClose ? (
                    <IconButton onClick={onClose} size="large">
                        <CloseIcon />
                    </IconButton>
                ) : null}
            </Box>
        }
        onClose={onClose}
    >
        <StyColoredText variant="body1">{children}</StyColoredText>
    </StyAlert>
);
export default Alert;
